import React from 'react';

import { getEmbedUrl, isValidFirebaseUrl, isValidNaviSaviUrl } from 'utils/string';

const Youtube = ({ url, pointerDisable = false }) => {
  const embedUrl = getEmbedUrl(url);
  let returnView = null;

  const pointerEvent = pointerDisable ? 'none' : 'auto';

  if (embedUrl && (isValidNaviSaviUrl(embedUrl) || isValidFirebaseUrl(embedUrl))) {
    let naviSaviUrl = embedUrl;
    if (!embedUrl.includes('#t=')) {
      naviSaviUrl = embedUrl + '#t=0.001';
    }
    returnView = (
      <video
        style={{ width: 'inherit', height: 'inherit', 'background-color': 'black', pointerEvents: pointerEvent }}
        controls={!pointerDisable}
      >
        <source src={naviSaviUrl} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    );
  } else {
    returnView = (
      <iframe
        src={embedUrl}
        frameBorder="0"
        style={{ width: '100%', height: '100%', pointerEvents: pointerEvent }}
        title="Youtube preview"
      ></iframe>
    );
  }
  return returnView;
};

export default Youtube;
